var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{ flex: _vm.flex, hborder: _vm.hborder }},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_vm._t("action")],2),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }